<script lang="ts">
    import type {CapabilityOnBuildings, LoanRequestOption} from 'src/typings';
    import {pipe} from 'core/utils';
    import {inline, prop} from 'shared/utils/pipes';

    export let option: LoanRequestOption<CapabilityOnBuildings>;
</script>

<div class="loan-request-option-buildings-list">
    <strong>{pipe(option.capability.buildings, prop('text'), inline(', '))}</strong>
</div>